// extracted by mini-css-extract-plugin
var _1 = "ToolTipStyle-module__info___Vx46k";
var _2 = "ToolTipStyle-module__tooltip___jbSdK";
var _3 = "ToolTipStyle-module__tooltip-purple___nn8b9";
var _4 = "ToolTipStyle-module__tooltip-purple___nn8b9";
export { _1 as "info", _2 as "tooltip", _3 as "tooltip-purple", _4 as "tooltipPurple" }
